// src/places/placesApi.ts
import { apiClient } from "@maat/api-base";
var placesApi = {
  autocomplete: async (params) => {
    return apiClient.get("/main/api/places/autocomplete", { params });
  },
  getPlaceDetails: async (placeId, sessionToken) => {
    return apiClient.get(`/main/api/places/${placeId}`, {
      params: sessionToken ? { sessionToken } : void 0
    });
  },
  /**
   * Resolves a coordinate back to an address. Resolves to `null` when the point
   * has no address or the upstream is unavailable — the server never errors here,
   * because the only thing this saves is typing.
   */
  reverseGeocode: async (lat, lng) => {
    return apiClient.get("/main/api/places/reverse", { params: { lat, lng } });
  }
};

export {
  placesApi
};
